/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TutorInfo model module.
 * @module model/TutorInfo
 * @version 1.0.0
 */
class TutorInfo {
    /**
     * Constructs a new <code>TutorInfo</code>.
     * @alias module:model/TutorInfo
     * @param dni {String} 
     * @param name {String} 
     * @param phone {String} 
     */
    constructor(dni, name, phone) { 
        
        TutorInfo.initialize(this, dni, name, phone);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, dni, name, phone) { 
        obj['dni'] = dni;
        obj['name'] = name;
        obj['phone'] = phone;
    }

    /**
     * Constructs a <code>TutorInfo</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TutorInfo} obj Optional instance to populate.
     * @return {module:model/TutorInfo} The populated <code>TutorInfo</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TutorInfo();

            if (data.hasOwnProperty('dni')) {
                obj['dni'] = ApiClient.convertToType(data['dni'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phone')) {
                obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} dni
 */
TutorInfo.prototype['dni'] = undefined;

/**
 * @member {String} name
 */
TutorInfo.prototype['name'] = undefined;

/**
 * @member {String} email
 */
TutorInfo.prototype['email'] = undefined;

/**
 * @member {String} phone
 */
TutorInfo.prototype['phone'] = undefined;






export default TutorInfo;

